import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';

// -----------------------------------------------------------------------------
// Accordions
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    Accordion.create();
});

// -----------------------------------------------------------------------------
// Scroll the page to content body by clicking hero cta link
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        new ScrollToElement(element).handleClick();
    }
});
